import '../styles/App.css';
import { BrowserRouter as Navigate, createBrowserRouter, RouterProvider } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import Home from '../pages/home/home';
import {EstimaGas} from '../pages/estimagas/estimagas';
import Termos from '../pages/termos/termo';
import Acessibilidade from '../pages/acessibilidade/acessibilidade';

const logoIcon = '/public/icons/logo-estimagas.ico';

const router = createBrowserRouter([
  {
    path:'/',
    element: 
      <>
        <Helmet> 
          <title>EstimaGás</title>        
          <meta name='descrição' content='Descrição'/>
        </Helmet>
        <Home/>
      </>
  },
  {
    path:'/estimagas',
    element: 
      <>
        <Helmet> 
          <title>ESTIMAGÁS</title>
          <meta name='descrição' content='Descrição'/>
        </Helmet>
        <EstimaGas/>
      </>
  },
  {
    path:'/termos-de-uso',
    element: 
      <>
        <Helmet> 
          <title>Termos de Uso</title>        
          <meta name='descrição' content='Descrição'/>
        </Helmet>
        <Termos/>
      </>
  },
  {
    path:'/manual',
    element: 
      <>
        <Helmet> 
          <title>Manual</title>        
          <meta name='descrição' content='Descrição'/>
        </Helmet>
        <Termos/>
      </>
  },
  {
    path:'/acessibilidade',
    element: 
      <>
        <Helmet>
          <title>Acessibilidade</title>
          <meta name='descrição' content='Recursos de Acessibilidade'/>
        </Helmet>
        <Acessibilidade/>
      </>
  },
  {
    path:'*',
    element: <Navigate to="/" />
  },
])

function App() {
  return <RouterProvider router={router}/>
}

export default App;
